export default [
    {
        path: '/home',
        name: 'HomePage',
        component: () => import('../Home/HomePage.vue'),
        // component: () => import('../Report/ReportPage.vue'),
    },
    {
        path: '/akun-profil',
        name: 'ProfilePage',
        component: () => import('../Profile/ProfilePage.vue'),
    },
    {
        path: '/h5p',
        name: 'H5PPage',
        component: () => import('../H5P/H5PPage.vue'),
        // sementara dibatasi ke akun uji coba saja
        // TODO: guard dimatikan sementara untuk testing H5P, aktifkan lagi
        // meta: { emails: ['skollasma@gmail.com'], fullBleed: true },
        // fullBleed: halaman memenuhi area konten tanpa padding (lihat MainPage)
        meta: { fullBleed: true },
    },

    // Start Menu Bahan Ajar
    {
        path: '/bahan-ajar',
        name: 'ContentListPage',
        component: () => import('../Content/ContentListPage.vue'),
        meta: { scopes: ['app_menu_bahan_ajar'] },
    },
    {
        path: '/form-bahan-ajar',
        name: 'FormLearningContentPage',
        component: () => import('../Content/FormLearningContentPage.vue'),
        meta: { scopes: ['app_menu_bahan_ajar'] },
    },
    {
        path: '/video-belajar',
        name: 'VideoLearningListPage',
        component: () => import('../Content/VideoLearningListPage.vue'),
        meta: { scopes: ['app_menu_bahan_ajar'] },
    },
    {
        path: '/modul-belajar',
        name: 'ModuleLearningListPage',
        component: () => import('../Content/ModuleLearningListPage.vue'),
        meta: { scopes: ['app_menu_bahan_ajar'] },
    },
    {
        path: '/materi-saya',
        name: 'DocumentLearningListPage',
        component: () => import('../Content/DocumentLearningListPage.vue'),
        meta: { scopes: ['app_menu_bahan_ajar'] },
    },
    // End Menu Bahan Ajar

    // Start Menu Quiz
    {
        path: '/assignment',
        name: 'QuizListPage',
        component: () => import('../Quiz/QuizListPage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    {
        path: '/form-assignment',
        name: 'FormQuizPage',
        component: () => import('../Quiz/FormQuizPage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    {
        path: '/buat-kuis',
        name: 'FormCreateBundlePage',
        component: () => import('../Quiz/FormCreateBundlePage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    {
        path: '/buat-kuis-manual',
        name: 'FormCreateBundleManualPage',
        component: () => import('../Quiz/FormCreateBundleManualPage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    {
        path: '/siswa-eligible',
        name: 'EligibleStudentPage',
        component: () => import('../Quiz/EligibleStudentPage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },

    {
        path: '/lembar-ujian-siswa',
        name: 'QuizTeacherReview',
        component: () => import('../Quiz/QuizTeacherReview.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    // End Menu Quiz

    // Start Menu Live Teaching
    {
        path: '/live-teaching',
        name: 'LiveTeachingListPage',
        component: () => import('../LiveTeaching/LiveTeachingListPage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    // End Menu Live Teaching

    // Start Menu Tugas
    {
        path: '/tugas',
        name: 'TaskListPage',
        component: () => import('../Task/TaskListPage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    {
        path: '/form-tugas',
        name: 'FormTaskPage',
        component: () => import('../Task/FormTaskPage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    {
        path: '/tugas/pengumpulan',
        name: 'TaskSubmissionPage',
        component: () => import('../Task/TaskSubmissionPage.vue'),
        meta: { scopes: ['app_menu_quiz'] },
    },
    // End Menu Tugas

    // Start Menu Report
    {
        path: '/report',
        name: 'ReportPage',
        component: () => import('../Report/ReportPage.vue'),
        meta: { scopes: ['app_menu_dashboard_monitoring'] },
    },
    {
        path: '/report/detail-tes',
        name: 'DetailReportQuizPage',
        component: () => import('../Report/DetailReportQuizPage.vue'),
        meta: { scopes: ['app_menu_dashboard_monitoring'] },
    },
    {
        path: '/report/proctoring',
        name: 'ProctoringReportPage',
        component: () => import('../Report/ProctoringReportPage.vue'),
        meta: { scopes: ['app_menu_dashboard_monitoring'] },
    },
    {
        path: '/report/keaktifan-siswa',
        name: 'KeaktifanSiswaPage',
        component: () => import('../Report/KeaktifanSiswaPage.vue'),
        meta: { scopes: ['app_menu_keaktifan_siswa'] },
    },
    {
        path: '/report/keaktifan-guru',
        name: 'KeaktifanGuruPage',
        component: () => import('../Report/KeaktifanGuruPage.vue'),
        meta: { scopes: ['app_menu_keaktifan_guru'] },
    },
    {
        path: '/report/analisis-butir-soal',
        name: 'AnalisisButirSoalPage',
        component: () => import('../Report/AnalisisButirSoalPage.vue'),
        meta: { scopes: ['app_menu_dashboard_monitoring'] },
    },
    {
        path: '/report/analisis-butir-soal/ctt',
        name: 'AnalisisCTTPage',
        component: () => import('../Report/AnalisisCTTPage.vue'),
        meta: { scopes: ['app_menu_dashboard_monitoring'] },
    },
    {
        path: '/report/analisis-butir-soal/irt',
        name: 'AnalisisIRTPage',
        component: () => import('../Report/AnalisisIRTPage.vue'),
        meta: { scopes: ['app_menu_dashboard_monitoring'] },
    },
    {
        path: '/report/monitoring',
        name: 'MonitoringPage',
        component: () => import('../Proctor/MonitoringPage.vue'),
        meta: { scopes: ['app_menu_dashboard_monitoring'] },
    },
    {
        path: '/report/absensi',
        name: 'AbsensiReportPage',
        component: () => import('../Report/AbsensiReportPage.vue'),
        meta: { scopes: ['app_menu_presensi'] },
    },
    {
        path: '/report/absensi/pengajuan',
        name: 'PengajuanAbsensiPage',
        component: () => import('../Report/PengajuanAbsensiPage.vue'),
        meta: { scopes: ['app_menu_presensi'] },
    },
    {
        path: '/report/absensi/siswa/:id',
        name: 'DetailSiswaAbsensiPage',
        component: () => import('../Report/DetailSiswaAbsensiPage.vue'),
        meta: { scopes: ['app_menu_presensi'] },
    },
    {
        path: '/report/rapor/guru-mapel',
        name: 'RaporGuruMapelPage',
        component: () => import('../Report/RaporGuruMapelPage.vue'),
        meta: { scopes: ['app_menu_rapor'] },
    },
    {
        path: '/report/rapor/guru-mapel/input-nilai',
        name: 'InputNilaiAkhirPage',
        component: () => import('../Report/InputNilaiAkhirPage.vue'),
        meta: { scopes: ['app_menu_rapor'] },
    },
    {
        path: '/report/rapor/guru-mapel/edit-nilai',
        name: 'EditNilaiAkhirPage',
        component: () => import('../Report/EditNilaiAkhirPage.vue'),
        meta: { scopes: ['app_menu_rapor'] },
    },
    {
        path: '/report/monitoring/detail',
        name: 'MonitoringDetailPage',
        component: () => import('../Proctor/MonitoringDetailPage.vue'),
        meta: { scopes: ['app_menu_dashboard_monitoring'] },
    },
    // {
    //     path: '/report/absensi',
    //     name: 'AbsensiReportPage',
    //     component: () => import('../Report/AbsensiReportPage.vue'),
    //     meta: { scopes: ['app_menu_dashboard_monitoring'] },
    // },
    // {
    //     path: '/report/absensi/pengajuan',
    //     name: 'PengajuanAbsensiPage',
    //     component: () => import('../Report/PengajuanAbsensiPage.vue'),
    //     meta: { scopes: ['app_menu_dashboard_monitoring'] },
    // },
    // {
    //     path: '/report/absensi/siswa/:name',
    //     name: 'DetailSiswaAbsensiPage',
    //     component: () => import('../Report/DetailSiswaAbsensiPage.vue'),
    //     meta: { scopes: ['app_menu_dashboard_monitoring'] },
    // },
    // {
    //     path: '/report/rapor/guru-mapel',
    //     name: 'RaporGuruMapelPage',
    //     component: () => import('../Report/RaporGuruMapelPage.vue'),
    //     meta: { scopes: ['app_menu_dashboard_monitoring'] },
    // },
    // {
    //     path: '/report/rapor/guru-mapel/input-nilai',
    //     name: 'InputNilaiAkhirPage',
    //     component: () => import('../Report/InputNilaiAkhirPage.vue'),
    //     meta: { scopes: ['app_menu_dashboard_monitoring'] },
    // },
    // {
    //     path: '/report/rapor/guru-mapel/edit-nilai',
    //     name: 'EditNilaiAkhirPage',
    //     component: () => import('../Report/EditNilaiAkhirPage.vue'),
    //     meta: { scopes: ['app_menu_dashboard_monitoring'] },
    // },
    {
        path: '/report/rapor/wali-kelas',
        name: 'RaporWaliKelasPage',
        component: () => import('../Report/RaporWaliKelasPage.vue'),
        meta: { scopes: ['app_menu_rapor'] },
    },
    {
        path: '/report/rapor/wali-kelas/edit-catatan',
        name: 'EditCatatanWaliKelasPage',
        component: () => import('../Report/EditCatatanWaliKelasPage.vue'),
        meta: { scopes: ['app_menu_rapor'] },
    },
    {
        path: '/report/rapor/wali-kelas/siswa',
        name: 'RaporBelajarSiswaPage',
        component: () => import('../Report/RaporBelajarSiswaPage.vue'),
        meta: { scopes: ['app_menu_rapor'] },
    },
    {
        path: '/report/rapor/admin',
        name: 'RaporAdminPage',
        component: () => import('../Report/RaporAdminPage.vue'),
        meta: { scopes: ['app_menu_rapor'] },
    },
    // End Menu Report

    // Start Menu Account
    {
        path: '/akun',
        name: 'AccountListPage',
        component: () => import('../Data/AccountListPage.vue'),
        meta: { scopes: ['app_menu_user'] },
    },
    {
        path: '/form-akun',
        name: 'FormAccountPage',
        component: () => import('../Data/FormAccountPage.vue'),
        meta: { scopes: ['app_menu_user'] },
    },
    // End Menu Account

    // Start Menu Student
    {
        path: '/siswa',
        name: 'StudentListPage',
        component: () => import('../Data/StudentListPage.vue'),
        meta: { scopes: ['app_menu_student'] },
    },
    // End Menu Student

    // Start Menu Study Group
    {
        path: '/rombel',
        name: 'RombelListPage',
        component: () => import('../Data/RombelListPage.vue'),
        meta: { scopes: ['app_menu_study_group'] },
    },
    // End Menu Study Group

    // Start Menu Role
    {
        path: '/role',
        name: 'RoleListPage',
        component: () => import('../Data/RoleListPage.vue'),
        meta: { scopes: ['app_menu_role_access'] },
    },
    // End Menu Role

    // Start Menu Mapel
    {
        path: '/mata-pelajaran',
        name: 'MapelListPage',
        component: () => import('../Data/MapelListPage.vue'),
        meta: { scopes: ['app_menu_bank_soal'] },
    },
    // End Menu Mapel

    // Start Menu Nilai
    {
        path: '/nilai',
        name: 'NilaiListPage',
        component: () => import('../Data/NilaiListPage.vue'),
        meta: { scopes: ['app_menu_rapor'] },
    },
    // End Menu Nilai

    // Start Menu Lokasi Absensi
    {
        path: '/bab',
        name: 'BabListPage',
        component: () => import('../Data/BabListPage.vue'),
        meta: { scopes: ['app_menu_bank_soal'] },
    },
    // End Menu Bab

    // Start Menu Lokasi Absensi
    {
        path: '/lokasi-presensi',
        name: 'SetLokasiPresensiPage',
        component: () => import('../Data/SetLokasiPresensiPage.vue'),
        meta: { scopes: ['app_menu_presensi'] },
    },
    // End Menu Lokasi Absensi

    // Start Bank Soal
    {
        path: '/upload-bank-soal',
        name: 'UploadBankSoalPageVue',
        component: () => import('../BankSoal/UploadBankSoalPage.vue.vue'),
        meta: { scopes: ['app_menu_bank_soal'] },
    },
    {
        path: '/bank-soal',
        name: 'BankSoalPageVue',
        component: () => import('../BankSoal/ListBankSoal.vue'),
        meta: { scopes: ['app_menu_bank_soal'] },
    },
    // End Bank Soal

    // Start Page Not Found
    {
        path: '/halaman-tidak-tersedia',
        name: 'AppPageNotFound',
        component: () =>
            import('@/modules/global/components/AppPageNotFound.vue'),
    },
    // End Page Not Found
];
